var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('JwPagination',{ref:"jwPagination",attrs:{"items":_vm.pages,"pageSize":1,"initialPage":_vm.current,"maxPages":_vm.maxPages},on:{"changePage":_vm.onChangePage}})}
var staticRenderFns = []

export { render, staticRenderFns }